import { prop } from '@ipfabric/utils/fp/prop';
import {
  type GraphState,
  isPathLookupGraphMetadata,
} from 'components/Graph/GraphState';
import { flow } from 'fp-ts/lib/function';

export const selectPathLookupApplied: (s: GraphState) => boolean = flow(
  prop('graphMetadata'),
  isPathLookupGraphMetadata,
);
